import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddBlockedPhoneNumberActions from './add-blocked-phone-number.actions';

export const addBlockedPhoneNumberFeatureKey = 'addBlockedPhoneNumber';

export interface AddBlockedPhoneNumberState {
   callState: CallState;
}

export const initialState: AddBlockedPhoneNumberState = {
   callState: LoadingState.Init,
};

const addBlockedPhoneNumberReducer = createReducer(
   initialState,
   onReset(initialState),
   on(
      AddBlockedPhoneNumberActions.createBlockedPhoneNumber,
      AddBlockedPhoneNumberActions.createBlockedPhoneNumberAndAddAnother,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loading,
         };
      }
   ),
   on(
      AddBlockedPhoneNumberActions.createBlockedPhoneNumberSuccess,
      AddBlockedPhoneNumberActions.createBlockedPhoneNumberFailure,
      AddBlockedPhoneNumberActions.createBlockedPhoneNumberAndAddAnotherSuccess,
      AddBlockedPhoneNumberActions.createBlockedPhoneNumberAndAddAnotherFailure,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Loaded,
         };
      }
   )
);

export function reducer(state: AddBlockedPhoneNumberState | undefined, action: Action) {
   return addBlockedPhoneNumberReducer(state, action);
}
